exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-close-popup {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  top: 15px;\n  right: 10px; }\n  .btn-close-popup img {\n    width: 100%; }\n\n.title {\n  font-size: 18px;\n  font-weight: 700;\n  padding: 15px 10px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  border-bottom: 1px solid #dfe1e6;\n  margin-bottom: 15px; }\n\n.icon-close {\n  -moz-appearance: none;\n       appearance: none;\n  border: 0;\n  outline: 0;\n  background: none; }\n\n.active {\n  background-color: #e4edff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-list/dialog-list.component.scss
// module id = 919
// module chunks = 22